import {createAction} from 'redux-actions'

const action = name => createAction(`SHARE_ARTICLE_MODAL_${name}`)

export const showModal = action('SHOW')
export const hideModal = action('HIDE')
